var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFitLenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#F5FAFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2438 47.0759C41.1417 50.1858 38.8899 57.2575 37.7603 62.3019C37.3026 64.3457 38.5951 66.2975 40.611 66.8656L49.2696 69.3057C50.951 69.7795 52.7715 69.1763 53.4836 67.5812C55.6379 62.7561 56.7076 55.3476 58.9338 52.6029C64.9124 45.2318 66.7789 41.549 65.9353 38.5002C64.6306 33.785 51.0888 29.3895 50.9883 34.2881C50.8623 40.427 47.5143 40.7577 43.2438 47.0759Z",
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3082 23.2148L44.698 22.169C44.4143 22.0633 44.0998 22.0774 43.8266 22.208C43.5535 22.3387 43.3452 22.5747 43.2494 22.8619L44.3082 23.2148ZM72.8341 33.8468H73.9501C73.9501 33.3808 73.6605 32.9638 73.2238 32.801L72.8341 33.8468ZM66.1261 53.3488L67.0404 53.9888L66.1261 53.3488ZM58.1298 78.5012L57.7544 79.5523C58.086 79.6707 58.4539 79.6257 58.7472 79.431C59.0404 79.2363 59.2246 78.9146 59.2442 78.5631L58.1298 78.5012ZM28.3602 67.8692L27.2571 68.0389C27.3195 68.444 27.5989 68.7824 27.9849 68.9203L28.3602 67.8692ZM36.8659 42.3524L37.7469 43.0376L36.8659 42.3524ZM43.9185 24.2606L72.4443 34.8926L73.2238 32.801L44.698 22.169L43.9185 24.2606ZM71.718 33.8468C71.718 34.7152 71.8955 36.7906 71.1818 39.9842C70.468 43.178 68.8522 47.5082 65.2118 52.7087L67.0404 53.9888C70.8425 48.5573 72.5806 43.959 73.3602 40.471C74.1398 36.9828 73.9501 34.6232 73.9501 33.8468H71.718ZM65.2118 52.7087C59.864 60.3485 57.3763 71.9444 57.0155 78.4393L59.2442 78.5631C59.5921 72.2996 62.0182 61.1634 67.0404 53.9888L65.2118 52.7087ZM58.5052 77.4502L28.7356 66.8182L27.9849 68.9203L57.7544 79.5523L58.5052 77.4502ZM29.4633 67.6995C28.8028 63.406 29.8056 53.2481 37.7469 43.0376L35.985 41.6672C27.6796 52.3457 26.5001 63.1181 27.2571 68.0389L29.4633 67.6995ZM37.7469 43.0376C45.3295 33.2884 44.4646 26.2755 45.367 23.5677L43.2494 22.8619C42.0258 26.5334 43.2869 32.2789 35.985 41.6672L37.7469 43.0376Z",
    fill: "#011E29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0381 36.6074L65.0113 43.3038",
    stroke: "#011E29",
    strokeWidth: 2.23214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3672 54.0469L60.5442 64.509",
    stroke: "#011E29",
    strokeWidth: 2.23214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8115 40.2246L67.2419 49.999",
    stroke: "#011E29",
    strokeWidth: 2.23214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6406 61.1602L52.7299 67.8566",
    stroke: "#011E29",
    strokeWidth: 2.23214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitLenses);
export default __webpack_public_path__ + "static/media/fit-lenses.a2892e7588607547a5279f2459a9e36e.svg";
export { ForwardRef as ReactComponent };